import {Binding, GraphObject} from 'gojs';

import {container, row, col, text} from 'src/util/gojs/components';
import {margin} from 'src/util/gojs/utils';
import {promptFont} from 'src/util/gojs/styles/fonts';
import {APPLICATION_GRAPH_NODE_RADIUS} from 'src/util/gojs/constants';
import {
  colorSecondaryLightGray as TEXT_COLOR,
  colorSecondaryDarkBlue as TITLE_COLOR,
} from 'src/styles/colors';

import {impactScore, link} from './components';

const NAME_TEXT_WIDTH = APPLICATION_GRAPH_NODE_RADIUS * 2 - APPLICATION_GRAPH_NODE_RADIUS * 0.2;
const END_SLICE_LENGTHS = 20; // 8.5;
const BASE_FONT_SIZE = 1.5;

export const makePanel = () =>
  container([
    row([
      col([
        {margin: margin(0)},
        col([
          {
            stretch: GraphObject.Fill,
            margin: margin(30, 0, 20),
          },
          col([
            text([

              {
                font: promptFont(0.75),
                stroke: TEXT_COLOR,
              },
              new Binding('text', 'data', ({type}) => type.toUpperCase()),
            ]),
          ]),
          col([
            text([
              {
                font: promptFont(2),
                stroke: TITLE_COLOR,
                margin: margin(10, 0, 10),
                textAlign: 'center',
                width: NAME_TEXT_WIDTH,
              },
              new Binding('font', 'data', ({name}: {name: string}) => promptFont(BASE_FONT_SIZE)),
              new Binding('text', 'data', ({name}: {name: string}) => {
                const displayName = `${name}`.replace(/-/g, `-\u200B`);
                return displayName.length > 90 ? `${displayName.substring(0, END_SLICE_LENGTHS)}…${displayName.substring(displayName.length - END_SLICE_LENGTHS, displayName.length)}` : displayName;
              }),
            ]),
          ]),
          col([
            link(['Dashboard']),
          ]),
        ]),
        col([
          impactScore(),
        ]),
      ]),
    ]),
  ]);
